(async function() {
  const css = `
  .meerkat-modal {
  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  background-color: rgba(0,0,0,0.6); /* Black w/ opacity */
  display: flex; /* Using flexbox to center modal */
  align-items: center; /* This centers the modal vertically in the viewport */
  justify-content: center; /* This centers the modal horizontally in the viewport */
}

/* Modal Content/Box */
.meerkat-modal-content {
  background-color: #111111;
  border: 1px solid #222222;
  width: 80%;
  max-width: 780px;
  display: flex;
  align-items: stretch;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2); /* Optional: Adds a shadow to the modal */
  position: relative; /* This is required for the absolute positioning of the close button */
}

.meerkat-modal-text {
    margin: 20px;
}

/* The Close Button */
.meerkat-close {
  color: #aaa;
  position: absolute; /* Positioned relative to the .modal-content */
  top: 10px;
  right: 25px;
  font-size: 35px;
  font-weight: bold;
}

.meerkat-close:hover,
.meerkat-close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

/* Solid color image placeholder */
.meerkat-modal-img {
  background: url(https://www.auravinyl.com/cdn/shop/t/3/assets/ttrs-market-banner.jpg);
  background-size: cover;
  flex: 1;
  height: auto;
}

.meerkat-button {
  background-color: transparent;
  width: 100%;
  color: #e3fc02; /* Inherits the color from the parent element */
  border: 1px solid #e3fc02; /* Default color is current text color */
  padding: 8px 16px; /* Optional: Adjust padding to your preference */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px; /* Optional: Adjust font size to your preference */
  margin: 4px 2px; /* Optional: Adjust margin to your preference */
  cursor: pointer;
  border-radius: 4px; /* Optional: Adjust border radius to your preference */
  transition: background-color 0.3s, color 0.3s; /* Optional: Adds a transition effect */
}

/* Optional: Style for hover state */
.meerkat-button:hover {
  background-color: #f2f2f2; /* Light grey background on hover */
  color: #000000; /* Change text color on hover if needed */
}

.meerkat-input {
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  font-size: 16px;
  display: block;
  box-sizing: border-box; 
  width: 100%;
  user-select: text !important;
}

.meerkat-input-error {
  border: 2px solid #ff0000;
}

.meerkat-input::selection {
  background-color: #aaa;
}

.meerkat-small {
  font-size: 12px;
}

.meerkat-wrapper {
  max-width: 66%;
}

#no-thanks {
cursor: pointer;
}

.meerkat-wrapper a {
  color: #e3fc02 !important;
}

#MeerkatOpen {
   width: 93px;
   height: 93px;
   background: url(https://www.auravinyl.com/cdn/shop/t/3/assets/discount-icon.png);
   background-size: cover;
   position: fixed;
   bottom: 100px;
   right: 30px;
   cursor: pointer;
   z-index: 99;
}

/* Responsive styling */
@media screen and (max-width: 600px) {
  .meerkat-modal-content {
    width: 95%; /* Slightly less width on mobile for a small margin */
    flex-direction: column;
  }
  .meerkat-modal-img {
    display: none; /* Hide the placeholder on mobile */
  }
  .meerkat-wrapper {
  max-width: 100%;
}

#MeerkatOpen {
   width: 60px;
   height: 60px;
   bottom: 90px;
   right: 20px;
}
}
  `;

// const AB = (function() {
//   let storage = localStorage.getItem('meerkat_abtest2');
//   if (storage) return storage;
//   let r = Math.random() > 0.5 ? 'a' : 'b';
//   localStorage.setItem('meerkat_abtest2', r);
//   fetch('https://marketing.auravinyl.com/abtest', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({test: 'days', type: 'start', value: r})
//   });
//   return r;
// })();

const holidayRequest = await fetch('https://marketing.auravinyl.com/hollist');
const holidayJSON = await holidayRequest.json();
const holidays = holidayJSON.list;
const DISCOUNT_DAYS = 3;

function isTodayBetweenDates(start, end) {
  // Create date objects for the start and end dates within the current year
  const year = new Date().getFullYear();
  const startDate = new Date(`${start}, ${year}`);
  const endDate = new Date(`${end}, ${year}`);
  
  // Get today's date
  const today = new Date();
  
  // Set the time of today, start, and end dates to 00:00:00 for accurate comparison
  today.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  
  // Check if today is between the start and end dates (inclusive)
  return today >= startDate && today <= endDate;
}

let cachedSpecial;
function getSpecial() {
  if (cachedSpecial) return cachedSpecial;
  for (let i = 0; i < holidays.length; i++) {
      let holiday = holidays[i];
      if (isTodayBetweenDates(holiday.start, holiday.end)) {
        cachedSpecial = holiday;
      }
  }

  return cachedSpecial;
}

function getMonth() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  
  // Get the last day of the current month
  const lastDayOfMonth = new Date(year, month + 1, 0).getDate();

  // Check if the current date is less than a week away from the next month
  if (day > lastDayOfMonth - DISCOUNT_DAYS) {
    // If yes, increment the month by one, adjusting for year wrap
    const nextMonth = new Date(year, month + 1, 1);
    return monthName(nextMonth.getMonth());
  } else {
    // If no, just return the current month name
    return monthName(month);
  }
}

function monthName(monthIndex) {
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  return monthNames[monthIndex];
}

function getFrom() {
    let storage = localStorage.getItem('startDate');
    if (storage) return storage;
    const now = new Date();
    let month = monthName(now.getMonth());
    const day = now.getDate();
    let val = `${month} ${day}`;  // Ensures 2-digit day
    localStorage.setItem('startDate', val);
    return val;
}

function getTo() {
    let special = getSpecial();
    if (special) {
      return special.end;
    }
  
    let storage = localStorage.getItem('futureDate');
    if (storage) return storage;
    const now = new Date();
    const futureDate = new Date(now);
    futureDate.setDate(now.getDate() + DISCOUNT_DAYS);

    const month = monthName(futureDate.getMonth());
    const day = futureDate.getDate();

    let val = `${month} ${day}`;  // Ensures 2-digit day
    localStorage.setItem('futureDate', val);
    return val;
}

// Assuming the stored date is in the format "MMM DD" as returned by getTo()
function hasStoredDatePassed() {
  const storedDateString = localStorage.getItem('futureDate'); // Retrieve the date string from localStorage
  if (!storedDateString) {
    // console.log('No date stored in localStorage');
    return false;
  }

  const currentYear = new Date().getFullYear();
  const storedDate = new Date(`${storedDateString} ${currentYear}`);

  // Check if the stored date year needs to be incremented (case for end of year)
  if (new Date() > storedDate && new Date().getMonth() === 11 && storedDate.getMonth() === 0) {
    storedDate.setFullYear(storedDate.getFullYear() + 1);
  }

  const now = new Date();
  return now > storedDate; // Returns true if the stored date has passed
}

function getStart() {
    let special = getSpecial();
    if (special) {
      return special.start;
    }
  
    const now = new Date();
    const month = monthName(now.getMonth());
    const day = now.getDate();

    return `${month} ${day.toString()}`;
}

function readyDates() {
  if (hasStoredDatePassed() || getSpecial()) {
    localStorage.removeItem('futureDate');
    localStorage.removeItem('startDate');
  }
}

function getSale() {
  let special = getSpecial();
  if (special) {
    return getEmoji() + ' ' + special.name + ' Sale';
  }
  
  return `${getEmoji()} ${getMonth().toUpperCase()} Special`;
}

function getEmoji() {
  let special = getSpecial();
  if (special) {
    return special.emoji;
  }
  
  return '🚀';
}

function getDiscountOff() {
  let special = getSpecial();
  if (special) {
    if (special.amountOff) return special.amountOff;
  }
  
  return 50;
}

function getDiscountCode() {
  let special = getSpecial();
  if (special) {
    if (special.code) return special.code;
  }
  
  return 'HSKHJM';
}

function getShippingNotice() {
  let special = getSpecial();
  if (special && special.shippingNotice) {
    return '<p>This sale has a <a href="https://www.auravinyl.com/pages/shipping-notification">SHIPPING NOTICE</a></p>';
  }
  return '';
}

readyDates();

const dealDescription = function() {
  if (getFrom() == getTo()) {
    return `<p><b>TODAY ONLY!</b> Get $${getDiscountOff()} OFF a full roll. Act before it's gone!</p>`;
  } else {
    return `<p>Secure $${getDiscountOff()} OFF if you <b>order today</b>! Wait and the deal dwindles, but even on ${getTo()} you'll lock in a solid $${Math.round(getDiscountOff()*0.6)} OFF. The sooner you act, the more you save!</p>`;
  }
};

const html = `
<div id="myModal" class="meerkat-modal" style="display: none;">

  <!-- Modal content -->
  <div class="meerkat-modal-content">
    <div id="meerkat-email-entry" class="meerkat-wrapper">
        <span class="meerkat-close">&times;</span>
        <div class="meerkat-modal-text" style="flex: 2; padding-right: 20px;">
        <h2 style="color: #e3fc02 !important; text-transform: uppercase;">${getSale()}:<br/><span style="font-size: 50px;">$${getDiscountOff()} OFF</span></h2>
        <p>${getSale()}! <b>${getFrom()} - ${getTo()}</b></p>
        ${dealDescription()}
        <!-- Form for email input and submission -->
        ${getShippingNotice()}
        <input class="meerkat-input" id="email-input" type="email" placeholder="Email">
        <button id="submit-email" class="meerkat-button">GET DISCOUNT CODE</button>
        <p class="meerkat-small" id="no-thanks">NO THANKS</p>
        </div>
    </div>

    <div id="meerkat-phone-entry" class="meerkat-wrapper" style="display: none;">
        <span class="meerkat-close">&times;</span>
        <div class="meerkat-modal-text" style="flex: 2; padding-right: 20px;">
        <h2 style="color: #e3fc02 !important;">YOUR DISCOUNT CODE:</h2>
        <h4>${getDiscountCode()} - Up to $${getDiscountOff()} OFF</h4>
        <p>Use code ${getDiscountCode()} today for $${getDiscountOff()} off a full roll. The discount will dwindle to $${Math.round(getDiscountOff()*0.6)} on ${getTo()}. If you are ordering a partial roll, you can use code <b>YZWHGV</b> for 10% off.</p>
        ${getShippingNotice()}
        <p><b>Enter your phone number to get <b>exclusive offers</b> via text.</b></p>
        <!-- Form for email input and submission -->
        <input class="meerkat-input" id="phone-input" type="phone" placeholder="Phone Number">
        <button id="submit-phone" class="meerkat-button">GET TEXTS FOR EXCLUSIVE OFFERS</button>
        <p class="meerkat-small" id="no-thanks">NO THANKS</p>
        <p>&nbsp;</p>
        </div>
    </div>

    <div id="meerkat-thanks" class="meerkat-wrapper" style="display: none;">
        <span class="meerkat-close">&times;</span>
        <div class="meerkat-modal-text" style="flex: 2; padding-right: 20px;">
        <h2 style="color: #e3fc02 !important;">WELCOME TO AURA</h2>
        <p>If you own a shop, <a href="https://www.auravinyl.com/pages/shop-sign-up">sign up here</a> for wholesale pricing and marketing support!</p>
        <p><a href="https://discord.gg/xrHmQ53GhY" target="_blank">Join our Discord</a> to connect with us and thousands of community members.</p>
        <!-- Form for email input and submission -->
        <p class="meerkat-small" id="no-thanks">CLOSE</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        </div>
    </div>
    <div class="meerkat-modal-img">
      <!-- Solid color image placeholder -->
    </div>
  </div>
</div>
<div id="MeerkatOpen" />
`;

  if (localStorage.getItem('mkt_phone')) return;

  var style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
} else {
    style.appendChild(document.createTextNode(css));
}

// Append the style element to the head
document.head.appendChild(style);

    let state = 'email';
    let lastState;

  var newDiv = document.createElement('div');
  newDiv.innerHTML = html;
  document.body.appendChild(newDiv);

  let closes = document.querySelectorAll('.meerkat-close');
  closes.forEach(close => close.onclick = closeClick);

  let nothanks = document.querySelectorAll('#no-thanks');
  nothanks.forEach(close => close.onclick = closeClick);

  let modal = document.querySelector('#myModal');
  modal.style.display = 'none';

  let openBtn = document.querySelector('#MeerkatOpen');
  openBtn.style.display = 'none';

  let emailEntry = document.querySelector('#meerkat-email-entry');
  let phoneEntry = document.querySelector('#meerkat-phone-entry');
  let thanksPage = document.querySelector('#meerkat-thanks');

  function closeClick() {
    lastState = state;
    state = 'closed';
    modal.style.display = 'none';
    openBtn.style.display = '';
    localStorage.setItem('mkt_hidden', true);
  }

  openBtn.onclick = _ => {
    state = lastState;
    modal.style.display = 'flex';
    openBtn.style.display = 'none';
  };

  window.showMeerkat = _ => openBtn.onclick();
  window.hideAllMeerkat = _ => {
    modal.style.display = 'none';
    openBtn.style.display = 'none';
  };

  if (location.search.includes('showModal')) {
    modal.style.display = 'flex';
    openBtn.style.display = 'none';
  } else {
    if (localStorage.getItem('mkt_hidden')) closeClick();
    else {
      setTimeout(_ => {
        modal.style.display = 'flex';
        openBtn.style.display = 'none';
      }, 4000);
    }
  }

  function showFromState() {
    switch (state) {
      case 'email': 
        emailEntry.style.display = '';
        phoneEntry.style.display = 'none';
        thanksPage.style.display = 'none';
        break;

        case 'phone': 
        emailEntry.style.display = 'none';
        phoneEntry.style.display = '';
        thanksPage.style.display = 'none';
        break;

        case 'thanks': 
        emailEntry.style.display = 'none';
        phoneEntry.style.display = 'none';
        thanksPage.style.display = '';
        break;
    }
  }

  window.addEventListener('click', evt => {
    if (evt.target == modal) closeClick();
  });

  let emailInput = document.querySelector('#email-input');
  let phoneInput = document.querySelector('#phone-input');

  async function postSignup(obj) {
     let id = localStorage.getItem('mkt');
     if (id) obj.id = id;
     let req = await fetch('https://marketing.auravinyl.com/events/user', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(obj)
     });
     let json = await req.json();
     localStorage.setItem('mkt', json.id);

     let array = localStorage.getItem('anon_mkt_list');
     if (array && array.startsWith('[')) {
       localStorage.removeItem('anon_mkt_list');
       array = JSON.parse(array);
       array.forEach(uri => {
         fetch('https://marketing.auravinyl.com/events/meerkat', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({id: json.id, uri})
        });
       });
     }
  }

  function fixEmailTypos(email) {
    const commonTypos = {
        'gmai.com': 'gmail.com',
        'gmail.comm': 'gmail.com',
        'gmail.comm': 'gmail.com',
        'gmial.com': 'gmail.com',
        'gmailcom': 'gmail.com',
        'gmal.com': 'gmail.com',
        'gmail.comm': 'gmail.com',
        'yahooo.com': 'yahoo.com',
        'yaho.com': 'yahoo.com',
        'yhoo.com': 'yahoo.com',
        'yahoo.comm': 'yahoo.com',
        'hotmial.com': 'hotmail.com',
        'hotmai.com': 'hotmail.com',
        'hotmal.com': 'hotmail.com',
        'homail.com': 'hotmail.com',
        'hotmail.comm': 'hotmail.com',
        'outllok.com': 'outlook.com',
        'outlook.comm': 'outlook.com',
        'otlook.com': 'outlook.com',
        'outlook.comm': 'outlook.com'
    };

      const emailParts = email.split('@');
      if (emailParts.length !== 2) {
          return email; // Invalid email format
      }
      
      const domain = emailParts[1].toLowerCase();
      if (commonTypos[domain]) {
          emailParts[1] = commonTypos[domain];
      }

    if (emailParts[1].includes('.comu')) emailParts[1] = emailParts[1].replace('.comu', 'com');
    if (emailParts[1].includes('.con')) emailParts[1] = emailParts[1].replace('.com', 'com');
    if (emailParts[1].includes('.comm')) emailParts[1] = emailParts[1].replace('.comm', 'com');
      
      return emailParts.join('@');
    }
  

  function submitEmail() {
    let text = emailInput.value;
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (emailRegex.test(text)) {
      emailInput.classList.toggle('meerkat-input-error');
      postSignup({email: fixEmailTypos(text)});
      state = 'phone';
      showFromState();
      localStorage.setItem('mkt_hidden', true);
    } else {
      emailInput.value = '';
      emailInput.classList.toggle('meerkat-input-error');
    }
  }

  function submitPhone() {
    let text = phoneInput.value;
    var phoneRegex = /^\+?(\d{1,3})?[-. ]?\(?\d{1,3}\)?[-. ]?\d{1,4}[-. ]?\d{1,4}[-. ]?\d{1,9}$/;
    let phoneRegex2 = /^\+?(\d{1,3})?[-. ]?(\(\d{3}\)|\d{3})[-. ]?\d{3}[-. ]?\d{4}$/;

    if (phoneRegex.test(text) || phoneRegex2.test(text)) {
      phoneInput.classList.toggle('meerkat-input-error');
      postSignup({phone: text});
      state = 'thanks';
      showFromState();
      localStorage.setItem('mkt_phone', true);
      openBtn.style.display = 'none';
    } else {
      phoneInput.value = '';
      phoneInput.classList.toggle('meerkat-input-error');
    }
  }

  let emailSubmit = document.querySelector('#submit-email');
  emailSubmit.onclick = submitEmail;

  let phoneSubmit = document.querySelector('#submit-phone');
  phoneSubmit.onclick = submitPhone;

  document.body.addEventListener('keyup', evt => {
    if (evt.key == 'Enter') {
      if (state == 'email') submitEmail();
      else if (state == 'phone') submitPhone();
    }
  });
})();